import { getSearchParam } from '@/common/hooks/useSearchParam';
import { BrowserPersistence } from '@/util';
import Cookie from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const storage = new BrowserPersistence();

export function useCJTracking() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const cjevent = getSearchParam('cjevent', searchParams);

    if (cjevent) {
      storage.setItem('cjevent', cjevent);
      Cookie.set('cje', cjevent);
    }
  }, [searchParams]);
}
